// @ts-strict-ignore
import Space from 'antd/lib/space';
import Switch from 'antd/lib/switch';
import Text from 'antd/lib/typography/Text';
import Title from 'antd/lib/typography/Title';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateIsRunwayAdminLiveModeEnabled, updateIsRunwayAdminWebsocketEnabled } from '../../actions/ui';
import { RootState } from '../../reducers/reducers';
import { tryWebsocketConnect, tryWebsocketDisconnect } from '../../actions/ws';
import { selectRunwayAdminWebsocketsEnabled } from '../../selectors/selectors';

const RunwayAdminSettings: React.FC = () => {
    const dispatch = useDispatch();
    const liveModeEnabled = useSelector((state: RootState) => state.ui.uiConfig.runwayAdminLiveModeEnabled);
    const websocketsEnabled = useSelector(selectRunwayAdminWebsocketsEnabled);

    const updateLiveModeEnabled = (enabled) => {
        dispatch(updateIsRunwayAdminLiveModeEnabled(enabled));
    };

    const updateWebsocketConnection = (enabled) => {
        dispatch(updateIsRunwayAdminWebsocketEnabled(enabled));

        if (enabled) {
            dispatch(tryWebsocketConnect());
        } else {
            dispatch(tryWebsocketDisconnect());
        }
    };

    return (
        <Space
            direction="vertical"
            size="large"
            style={{
                width: '100%',
            }}
        >
            <Title level={5}>Runway admin settings</Title>
            <Space
                direction="vertical"
                style={{
                    width: '100%',
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Text>Enable live mode</Text>
                    <Switch checked={liveModeEnabled} onChange={(checked) => updateLiveModeEnabled(checked)}></Switch>
                </div>
                <Text type="secondary">
                    Warning! Enabling live mode means any actions you take on a production environment will have real
                    effects. Use at your own risk.
                </Text>
            </Space>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Text>Enable websocket connection</Text>
                <Switch
                    checked={websocketsEnabled}
                    onChange={(checked) => updateWebsocketConnection(checked)}
                ></Switch>{' '}
            </div>
        </Space>
    );
};

export default RunwayAdminSettings;
